<bolt-sidenav [navigationOptions]="navigationOptions" *ngIf="!isLoading">
  <app-layout-content></app-layout-content>
</bolt-sidenav>
<div class="card-container" *ngIf="isLoading">
  <mat-card class="mat-card-2">
    <!-- <img [src]="waitingImg" alt="" /> -->
    <mat-label>Loading application, please wait...</mat-label>
    <mat-spinner mode="indeterminate"></mat-spinner>
  </mat-card>
</div>
